module.exports = __webpack_public_path__ + "static/6_mobile-16a406b236a126d3d8a90dc2ecca0ddc.jpg";